/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */
import React from 'react';
import { ListGroup, ListGroupItem } from 'react-bootstrap';
import { HELPDESK_PHONE_NUMBERS_LABEL } from '../../const';
import { generateIteratorKey as keygen } from '../../utils/helpers';

class HelpdeskService {
  static createCountrySelectItems(countries) {
    if (null == countries) {
      return [];
    }
    let options = [];
    Object.keys(countries).map((key, index) =>
      options.push(
        <option {...keygen()} value={key}>
          {countries[key].name}
        </option>
      )
    );
    return options;
  }

  static createPhoneNumbersListItems(phoneNumbers) {
    let items = [];
    if (null == phoneNumbers) {
      return <div />;
    }
    phoneNumbers.forEach(function (element) {
      items.push(
        <ListGroupItem className="support-number" {...keygen()}>
          {element}
        </ListGroupItem>
      );
    });
    return (
      <div id="helpdesk-numbers">
        <label id="numbers-label">{HELPDESK_PHONE_NUMBERS_LABEL}</label>
        <ListGroup>{items}</ListGroup>
      </div>
    );
  }
}

export default HelpdeskService;
